import React, { useContext } from "react";
import { AsyncSearchStyled } from "./AsyncSearchStyled";
import CustomAsyncSelect from "../Select/CustomAsyncSelect/CustomAsyncSelect";
import { SearchService } from "../../services/SearchService";
import { getValueForKey } from "../../context/translationsUtils";
import { TranslationContextInterface } from "../../entities/Language";
import { TranslationContext } from "../../context/TranslationContext";
import {
  AsyncCondiment,
  AsyncMix,
  CustomAsyncSelectResponse,
  CustomAsyncSelectResultType,
} from "../../entities/CustomSelect";
import { useAppDispatch } from "../../store/store";
import { MODAL_TYPES } from "../../entities/Modal";
import { onOpenModal } from "../Modal/slice/ModalSlice";
import { TEST_ID } from "../../shared/testid";

const AsyncSearch: React.FC = () => {
  const dispatch = useAppDispatch();
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const onHandleChange = (option: AsyncMix | AsyncCondiment) => {
    const { type } = option;
    if (type === CustomAsyncSelectResultType.CONDIMENT) {
      const { id, name, image, description, recommendation, history } = option;
      dispatch(
        onOpenModal({
          modalType: MODAL_TYPES.PRODUCT_PREVIEW,
          content: {
            id,
            name,
            description,
            recommendation,
            history,
            image,
            type,
          },
        }),
      );
    }
    if (type === CustomAsyncSelectResultType.MIX) {
      const { id, name, description, image } = option;

      dispatch(
        onOpenModal({
          modalType: MODAL_TYPES.PRODUCT_PREVIEW,
          content: {
            id,
            name,
            description,
            image,
            type,
          },
        }),
      );
    }
  };

  const formatOptions = (data: CustomAsyncSelectResponse[]) => {
    return data.map((itemData: CustomAsyncSelectResponse) => {
      const { type, data: item } = itemData;
      return {
        ...item,
        label: item.name,
        value: item.id,
        type,
      };
    });
  };

  const onLoadOptions = (searchValue: string, callback: any) => {
    const params = {
      limit: 10,
      offset: 0,
      type: "",
      textFilter: searchValue.toLowerCase(),
    };
    if (searchValue)
      SearchService.searchAll(params).then(({ data }) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        callback(formatOptions(data));
      });
  };

  return (
    <AsyncSearchStyled>
      <CustomAsyncSelect
        noOptionsMessage={() =>
          getValueForKey(translations, "nav_bar.no_results")
        }
        loadingMessage={() => getValueForKey(translations, "nav_bar.loading")}
        loadOptions={(searchValue, callback) =>
          onLoadOptions(searchValue, callback)
        }
        onChange={(option) => onHandleChange(option)}
        id={TEST_ID.HEADER.SEARCH_BAR}
        placeholder={getValueForKey(
          translations,
          "nav_bar.search",
          undefined,
          true,
        )}
      />
    </AsyncSearchStyled>
  );
};

export default AsyncSearch;
